/**
 * Version stamp for the SysOps Panel. Bumped per PCB versioning rule on
 * every deployable build. Surfaced in the topbar + footer + console so Bill
 * can identify what's running.
 *
 * Keep aligned with package.json `version`. The build also stamps the
 * commit time.
 */

export const APP_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.16.0';

export const APP_BUILD_TIME = new Date().toISOString();

export const APP_NAME = 'PCB SysOps Panel';
